// TODO: this service should be split into multiple services, one each for count, find and query
import $ = require("jquery");
import FeatureLayer = require("arcgis/services/featureserver/layer");
import Query = require("arcgis/services/featureserver/query");
import Find = require("arcgis/services/mapserver/find");
import Utils = require("../../utils");
import Portal = require("portal-gis");
import Converter = require("../../utils/ags/converter");
import _ = require("underscore");
const log = Utils.log;

function asEpsgCode(spatialReference: any) {
    return `EPSG:${spatialReference.latestWkid || spatialReference.wkid}`;
}

interface QueryArgs {
    url: string;
    geometryType?: "esriGeometryPoint" | "esriGeometryMultipoint" | "esriGeometryPolyline" | "esriGeometryPolygon" | "esriGeometryEnvelope";
    inSR?: string;
    outSR?: string;
    geometry?: string;
    layers?: string;
    filter?: string;
    outFields?: string;
    options?: any;
}

// MapServer/*
const queryKeys = `searchText,contains,searchFields,sr,layers,layerDefs,returnGeometry,maxAllowableOffset,geometryPrecision,dynamicLayers,returnZ,returnM,gdbVersion,f`
    .split(',');

class Service {

    static about = `
Provides count, find and query proxies to the underlying ags.
    `;

    static options = {
        "searchText": "use find service to search for this value",
        "layers": "search these layers",
        "contains": "If false, the operation searches for an exact match of the searchText string. An exact match is case sensitive. Otherwise, it searches for a value that contains the searchText provided. This search is not case sensitive. The default is true.",
        "f": {
            about: "Response format, should always be json or pjson",
            default: "json"
        },
        "returnGeometry": "Include the geometry in the response",
        "returnIdsOnly": "Only return the feature ids",
        "returnCountOnly": "Only return the count of matching features",
    }

    // MapServer/find?searchText=test&contains=true&layers=17&&returnGeometry=true&f=pjson
    static find(args: {
        url: string;
        searchText: string;
        layers: string;
        options?: { [name: string]: any };
    }) {
        let d = $.Deferred<Rhythm.GIS.FeatureQueryResultLayer>();

        args.options = args.options || {};
        args.options["searchText"] = args.options["searchText"] || args.searchText;
        args.options["layers"] = args.options["layers"] || args.layers;
        args.options["contains"] = args.options["contains"] || "true";
        args.options["f"] = args.options["f"] || "json";

        let queryArgs = queryKeys.filter(k => undefined !== args.options[k]).map(k => `${k}=${args.options[k]}`).join('&');
        let url = `${args.url}/find?${queryArgs}`;

        log("geoquery:", url);

        // possibly features from multiple layers
        $.ajax({
            type: "GET",
            dataType: "text",
            proxy: false,
            url: url
        })
            .done((responseText: string, status: string) => {
                let data = <Find.RootObject>JSON.parse(responseText);
                if (data.results) {
                    let layer = <Rhythm.GIS.FeatureQueryResultLayer>{
                        spatialReference: {
                            wkid: <any>"EPSG:4326"
                        },
                        features: []
                    };
                    if (data.results.length) {
                        let srcSrs = asEpsgCode(data.results[0].geometry.spatialReference);
                        let converter = new Converter(srcSrs, "EPSG:4326");
                        layer.features = converter.fromNativeFeatures(data.results);
                    }
                    d.resolve(layer);
                } else if (data.error) {
                    console.warn(data.error);
                    d.reject(data.error.message);
                } else {
                    console.warn("unexpected result format");
                    d.reject(data);
                }
            });

        return d;
    }

    static count(args: QueryArgs) {
        let d = $.Deferred<number>();

        args.options = args.options || {};
        args.options.returnGeometry = "" + false;
        args.options.returnIdsOnly = "" + false;
        args.options.returnCountOnly = "" + true;

        Service.query(args)
            .fail(() => d.fail())
            .done(data => d.resolve(data["count"]));
        return d;
    }

    static ids(args: QueryArgs) {
        let d = $.Deferred<{
            objectIdFieldName: string;
            objectIds: Array<number>;
        }>();

        args.options = args.options || {};
        _.defaults(args.options, {
            returnGeometry: "" + false,
            returnIdsOnly: "" + true,
            returnCountOnly: "" + false
        });

        Service.query(args)
            .fail(() => d.fail())
            .done(data => d.resolve(<any>data));
        return d;
    }

    static data(args: QueryArgs) {
        args.options = args.options || {};
        _.defaults(args.options, {
            returnGeometry: "" + false,
            returnIdsOnly: "" + false,
            returnCountOnly: "" + false
        });
        return Service.query(args);
    }

    static geo(args: QueryArgs) {
        args.options = args.options || {};
        _.defaults(args.options, {
            returnGeometry: "" + true,
            returnIdsOnly: "" + false,
            returnCountOnly: "" + false
        });
        args.outFields = " "; // blank but not falsy
        return Service.query(args);
    }

    // MapServer/{layer}/query?where=&text=&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=4326&spatialRel=esriSpatialRelIntersects&relationParam=&outFields=*&returnGeometry=true&maxAllowableOffset=&geometryPrecision=&outSR=4326&returnIdsOnly=false&returnCountOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&gdbVersion=&returnDistinctValues=false&returnTrueCurves=false&resultOffset=&resultRecordCount=&f=json
    static query(args: QueryArgs) {
        let d = $.Deferred<Rhythm.GIS.FeatureQueryResultLayer>();

        if (!args.layers) {
            let urlParts = args.url.split("/");
            args.layers = urlParts.pop();
            args.url = urlParts.join("/");
        }

        let layerId = Utils.split(args.layers)[0];

        let queryInfo = {
            where: args.filter || "1=1",
            returnGeometry: !!args.geometry,
            returnIdsOnly: args.outFields === "",
            returnCountOnly: false,
            geometry: args.geometry,
            geometryType: args.geometryType || "esriGeometryEnvelope",
            inSR: args.inSR || "4326",
            outSR: args.outSR || "4326",
            outFields: args.outFields || "*",
            f: "json"
        };

        Utils.ifOption(args.options, "returnGeometry", v => queryInfo.returnGeometry = v !== "false");
        Utils.ifOption(args.options, "returnIdsOnly", v => queryInfo.returnIdsOnly = v !== "false");
        Utils.ifOption(args.options, "returnCountOnly", v => queryInfo.returnCountOnly = v !== "false");

        let url = `query`;
        if (layerId) url = `${layerId}/${url}`;
        url = `${args.url}/${url}`;

        log("geoquery:", url);

        $.ajax(url, {
            data: queryInfo,
            dataType: "text",
            type: "POST",
            proxy: false
        })
            .done((responseText: string, status) => {
                let data = <FeatureLayer.RootObject>JSON.parse(responseText);
                if (data["error"]) {
                    console.warn(data);
                    d.reject(data);
                } else if (data.fields) {
                    if (queryInfo.returnGeometry) {
                        let converter = new Converter(`EPSG:${queryInfo.outSR}`, "EPSG:4326");
                        d.resolve(converter.fromNativeQuery(data));
                    } else {
                        d.resolve(data);
                    }
                } else if (typeof data["count"] !== "undefined") {
                    d.resolve(data);
                } else if (data["objectIds"]) {
                    d.resolve(data);
                } else {
                    console.warn("unexpected result format");
                    d.resolve(data);
                }
            });

        return d;
    }

}

export = Service;